var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9834 5.6589L12.8412 2.51734C12.7367 2.41285 12.6127 2.32996 12.4762 2.2734C12.3397 2.21685 12.1933 2.18774 12.0456 2.18774C11.8978 2.18774 11.7515 2.21685 11.615 2.2734C11.4785 2.32996 11.3545 2.41285 11.25 2.51734L2.57977 11.1876C2.47485 11.2917 2.39167 11.4156 2.33506 11.5521C2.27844 11.6886 2.24953 11.835 2.25001 11.9828V15.1251C2.25001 15.4234 2.36853 15.7096 2.57951 15.9206C2.79049 16.1315 3.07664 16.2501 3.37501 16.2501H15.1875C15.3367 16.2501 15.4798 16.1908 15.5853 16.0853C15.6907 15.9798 15.75 15.8368 15.75 15.6876C15.75 15.5384 15.6907 15.3953 15.5853 15.2898C15.4798 15.1843 15.3367 15.1251 15.1875 15.1251H8.10844L15.9834 7.25007C16.0879 7.1456 16.1708 7.02157 16.2274 6.88507C16.2839 6.74856 16.313 6.60225 16.313 6.45449C16.313 6.30673 16.2839 6.16042 16.2274 6.02391C16.1708 5.8874 16.0879 5.76337 15.9834 5.6589ZM6.51727 15.1251H3.37501V11.9828L9.56251 5.79531L12.7048 8.93757L6.51727 15.1251ZM13.5 8.14234L10.3584 5.00007L12.0459 3.31257L15.1875 6.45484L13.5 8.14234Z",
    fill: "#363495"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.118a6cbea5c17ae9515a2c29b4dfde1c.svg";
export { ForwardRef as ReactComponent };